import { pickersPopperClasses } from "@mui/x-date-pickers/internals";
import { paperClasses, inputBaseClasses, outlinedInputClasses } from "@mui/material";

export const popperStyles = {
	// popper spacing
	[`&.${pickersPopperClasses.root}`]: {
		margin: "4px 0 !important",
	},
	// popper border/shadow
	[`& .${pickersPopperClasses.paper}.${paperClasses.root} `]: {
		borderRadius: "12px",
		border: "none",
		boxShadow: "0px 2px 8px 0px #2320202a",
	},
	// remove button ripples
	[" .MuiTouchRipple-root"]: {
		display: "none",
	},
	// remove scrollbars
	[`& ::-webkit-scrollbar`]: {
		width: 0,
	},
};

export const buttonStyles = {
	[":hover"]: {
		backgroundColor: "#eceaf1",
	},
	[":active"]: {
		backgroundColor: "#e3dfe9",
	},
	[":focus"]: {
		backgroundColor: "inherit",
		outline: "2px solid var(--focus-outline-color-dark)",
	},
	[":focus:active"]: {
		backgroundColor: "#c4bdd2",
	},
	["&.Mui-selected"]: {
		backgroundColor: "#42296e",
	},
	["&.Mui-selected:hover"]: {
		backgroundColor: "#3b2563",
	},
	["&.Mui-selected:active"]: {
		backgroundColor: "#352158",
	},
	["&.Mui-selected:focus"]: {
		outline: "2px solid var(--focus-outline-color-dark)",
		outlineOffset: "2px",
	},
};

export const inputTextFieldStyles = {
	display: "inline-block",
	// icon background
	["&&& .MuiIconButton-root"]: {
		padding: 3,
		marginRight: "-8px",
		border: "none",
		background: "none",
		...buttonStyles,
	},
	// input text field content
	["& .MuiInputBase-root"]: {
		paddingRight: "10px",
	},
	["& .MuiInputBase-input"]: {
		fontStyle: "normal",
		fontWeight: 400,
		fontSize: 13,
		height: 37,
		padding: "0 0 0 5px",
	},
	// input text field border
	[`& .MuiInputBase-root > input.${inputBaseClasses.input}:focus-visible`]: {
		borderWidth: "0px",
	},
	[`& fieldset.${outlinedInputClasses.notchedOutline}`]: {
		border: "1px solid #d0d0d0",
	},
	[`& .${outlinedInputClasses.root}:hover fieldset.${outlinedInputClasses.notchedOutline}`]: {
		border: "1px solid #d0d0d0",
	},
	// disabled input text field border
	[`& .${outlinedInputClasses.root}.Mui-disabled`]: {
		background: "rgb(250, 250, 250)",
		[`& input.${inputBaseClasses.input}`]: {},
		[`& fieldset.${outlinedInputClasses.notchedOutline}`]: {
			border: "1px solid rgb(208, 208, 208)",
		},
		[`&:hover & fieldset.${outlinedInputClasses.notchedOutline}`]: {
			border: "1px solid rgb(208, 208, 208)",
		},
	},
	// focused input text field border
	[`& .${outlinedInputClasses.root}.Mui-focused fieldset.${outlinedInputClasses.notchedOutline} `]: {
		border: "3px solid #0277ad",
	},
	// error input text field border
	[`&.CoreTimePicker-error, &.CoreDatePicker-error`]: {
		[`&, &:hover, &.Mui-focused, & .${outlinedInputClasses.root}.Mui-focused`]: {
			[`& fieldset.${outlinedInputClasses.notchedOutline}`]: {
				borderColor: "#bf0033",
			},
		},
		[`& .${outlinedInputClasses.root}.Mui-disabled fieldset.${outlinedInputClasses.notchedOutline}`]: {
			borderColor: "#bf0033",
		},
	},
};

// Material UI DesktopDatePicker UP and DOWN arrow keys break ONLY for MONTH view and ONLY if monthsPerRow is 4.
// You can test it here on Mui's official site: https://mui.com/x/react-date-pickers/date-picker/#views.
// This function patches Up/Down arrow keys for month view and when monthsPerRow is 4.
export function patchMonthViewArrowKeys(event: React.KeyboardEvent<HTMLDivElement>, container: Element | null) {
	if (!container) return;

	const buttons = Array.from(container.querySelectorAll<HTMLButtonElement>('button[role="radio"]'));
	const active = document.activeElement as HTMLButtonElement | null;
	const currentIndex = buttons.indexOf(active!);
	if (currentIndex === -1) return;

	if (event.key === "ArrowDown" || event.key === "ArrowUp") {
		event.preventDefault();
		event.stopPropagation();

		const nextIndex =
			event.key === "ArrowDown"
				? (currentIndex + 4) % buttons.length
				: (currentIndex - 4 + buttons.length) % buttons.length;

		buttons[nextIndex]?.focus();
	}
}
